// extracted by mini-css-extract-plugin
module.exports = {"Title":"styles_Title__vjA2W","Wrapper":"styles_Wrapper__2lYX_","ClearButton":"styles_ClearButton__Wa9QK"};